import type { BackgroundCheckAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type GroupBy,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryLimitToSQL,
  queryOrderToSQL,
} from './common'
import type { BackgroundCheckStatus } from './constants'

const BackgroundCheckQ = {
  ...makeQueryModelV2<BackgroundCheckAttributes>('background_check')([
    'id',
    'user_id',
    'submitted_at',
    'partner_name',
    'partner_user_id',
    'status',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  where: (
    {
      id,
      userId,
      status,
      groupBy = null,
      order = null,
      paranoid = true,
      limit = null,
    }: {
      id?: number | null | SQLFragment<number>
      userId?: number | null | SQLFragment<number>
      status?: BackgroundCheckStatus | null | SQLFragment<BackgroundCheckStatus>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      paranoid?: boolean
      limit?: number | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<BackgroundCheckAttributes> => SQL`
        FROM ${BackgroundCheckQ}
        WHERE
            ${id != null ? SQL`${BackgroundCheckQ.id} = ${id} AND` : SQL``}
            ${userId != null ? SQL`${BackgroundCheckQ.user_id} = ${userId} AND` : SQL``}
            ${status != null ? SQL`${BackgroundCheckQ.status} = ${status} AND` : SQL``}
            ${paranoid ? SQL`${BackgroundCheckQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        ${queryLimitToSQL(limit)}
    `,
}

export default BackgroundCheckQ
